import React from "react";
import { TrialProBadgeType, TrialProBadgeWithTooltip } from "../trial-pro-badge-with-tooltip";

type FocusTimeBadgeProps = {
  daysLeftOnTrial: number;
  isOnTrial: boolean;
};

export const FocusTimeBadge = ({ daysLeftOnTrial, isOnTrial }: FocusTimeBadgeProps) => {
  return (
    <div className="cw-ml-2" style={{ maxWidth: 50 }}>
      <TrialProBadgeWithTooltip
        colorOption={"green"}
        daysLeftOnTrial={daysLeftOnTrial}
        placement="bottom"
        showToolTip={isOnTrial}
        tooltipType={TrialProBadgeType.FocusTimeEnabled}
        width={280}
      />
    </div>
  );
};
